export default "__VITE_ASSET__BuguVWsc__"